/**
 * Capitalizes the first letter of a given string.
 * Example: "hello" -> "Hello"
 */
export function capitalizeFirstLetter(str: string) {
  // Take the first character, uppercase it, and append the rest of the string.
  return str.charAt(0).toUpperCase() + str.slice(1);
}

/**
 * Converts a string to lowercase and removes any accent/diacritic marks.
 * Example: "Éléphant" -> "elephant"
 */
export function toLowerCaseNoAccents(str: string): string {
  return str
    .toLowerCase() // Convert to lowercase
    .normalize("NFD") // Normalize to separate base chars and accents
    .replace(/\p{Diacritic}/gu, ""); // Remove all diacritic marks
}

/**
 * Checks whether the provided value is a string.
 */
export function isString(value: unknown) {
  // Returns true only if the value's type is exactly "string".
  return typeof value === "string";
}
